import { combineReducers } from 'redux';

import clients from './clients_reducer';

const rootReducer = combineReducers({
    clients
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_app/clients/reducers/index.js